import * as React from "react";
import {observer} from "mobx-react";
import {Box} from "@mui/material";
import LayoutContentTitle from "../../../components/layout/LayoutContentTitle";
import AllowanceScreen from "../../allowances/AllowanceScreen";
import Allowance from "../../allowances/Allowance";

function AllowanceConfirmationRequestComponent({allowance}) {
    if (!allowance) return null;

    const presentedAllowance = Allowance.forDisplay(allowance);

    return (
        <Box mt={2}>
            <Box mb={2}>
                <LayoutContentTitle title="Bonificación"/>
            </Box>
            <AllowanceScreen allowance={presentedAllowance}/>
        </Box>
    );
}

export default observer(AllowanceConfirmationRequestComponent);
